<div
  class="px-4 lg:px-12 xl:px-16 py-4 drop-shadow-md"
  [ngClass]="
    banner()?.darkBackground ? 'bg-black text-white' : 'bg-white text-ss-brown'
  "
>
  <div
    [innerHTML]="banner()?.message"
    [style]="{
      marginRight: '1.25rem',
      padding: '0 0.5rem',
    }"
  ></div>
  <div class="flex justify-end gap-4 flex-wrap mt-2">
    @for (button of banner()?.buttons; track $index) {
      <ss-building-block-button-link
        [buttonLink]="button.item"
      ></ss-building-block-button-link>
    }
  </div>
</div>

<button
  class="bg-ss-brown rounded-full p-1 absolute right-4 lg:right-12 top-8 md:top-6"
  (click)="closeBanner.emit()"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-4 h-4 text-white"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
</button>
